



























































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import JsonHandler from '@/components/jsonhandler/index.vue';
import _ from 'lodash';
import Loading from '@/util/loading';
import ToolBox from './ToolBox.vue';
import Message from '@/util/MessageWorker';

@Component({
  components: {
    JsonHandler,
    ToolBox
  }
})
export default class CompBox extends Vue {
  private componentList = [];
  private componentMap = {};
  private activeIndex = 2;
  private tree = [];
  private selectedNode = {};
  private currentNodeKey = '';
  private sceneList = [];
  private dataCode = `var data = {}`;
  private jsonData = '"{}"';
  private activeNameCode = 'code';
  private search = '';
  private customCompList = [];
  private widgetData = null;
  private fileList = [];
  private toolVisible = false;
  private openDrawer = false;
  private packageName = '';
  private pluginList = [];
  private installType = 1;

  get activeTreeIndex() {
    return AppModule.activeTreeIndex;
  }

  @Watch('uuid', { immediate: true })
  private uuidChange() {
    const componentTree: any = this.$refs.componentTree;
    componentTree && componentTree.setCurrentKey(this.uuid);
    this.selectedNode = {
      id: this.uuid
    };
  }

  get insertData() {
    return AppModule.insertData;
  }
  get uuid() {
    return AppModule.activeCompId;
  }

  async created() {
    const { type, params } = this.insertData.data;
    setTimeout(async () => {
      const componentMap = await Message.emit('generator.data.getCompList');
      this.componentMap = componentMap.data;
      if (type !== 'custominline') {
        this.componentList = componentMap[type];
      } else {
        this.componentList = componentMap[params.compBox];
      }
      this.getCustomComp = _.debounce(this.getCustomComp, 500, { trailing: true });
      this.getScene();
    }, 2000)

  }

  async getScene() {
    const res = await Message.emit('generator.scene.getScene');
    this.sceneList = res.data.list;
  }

  private async getSceneTree() {
    const tree = await Message.emit('generator.scene.getSceneTree');
    this.tree = [tree.data];
  }

  private async getSceneConfig() {
    const res = await Message.emit('generator.scene.getConfig', {});
    this.dataCode = res.dataCode;
  }

  private async getCustomComp(value) {
    const res = await Message.emit('generator.data.getCustomComp', {
      value
    });
    this.customCompList = res.data;
    if (res && res.length > 0) {
      this.$nextTick(() => {
        this.$root.$emit('bind_client_drag');
      });
    }
  }

  private tabChange(index) {
    const codemirror: any = this.$refs.codemirror;
    AppModule.setActiveTreeIndex(index);
    this.getSceneTree();
    this.getScene();
    this.getSceneConfig();
    this.getCustomComp('');
    this.getFileList();
    this.getPlugin();

    setTimeout(() => {
      codemirror.codemirror.refresh();
    }, 100);
  }

  private handleNodeClick(node) {
    Message.emitView('view.component.selected', {
      uuid: node.id
    })
    this.selectedNode = node;
  }

  private async deleteComponent(id) {
    await Message.emit('generator.scene.deleteComponent', {
      id
    });
    this.getSceneTree();
  }

  private compClick(uuid) {
    const viewFrame: any = document.querySelector('#viewContent');
    viewFrame.contentWindow.postMessage(
      { handler: 'tree-selected', uuid },
      '*'
    );
  }

  async useScene(id) {
    const res = await Message.emit('generator.toolbar.useScene', {
      id
    });
  }

  async deleteScene(id) {
    const res = await Message.emit('generator.toolbar.deleteScene', {
      id
    });
    this.getScene();
  }

  async addTableColumn(id, selectedNode) {
    let node = selectedNode.parent;
    while (node && !(node.label == 'Table' || node.label == 'page')) {
      node = node.parent;
    }
    // nextSibling
    const params = {
      boxUuid: node.key,
      nextSiblingId: selectedNode.nextSibling
        ? selectedNode.nextSibling.data.id
        : '',
      id: 'Table/column.ts'
    };

    await Message.emit('generator.scene.addComponent', params);
    this.getSceneTree();
  }

  private handleCodeClick() {
    if (this.activeNameCode === 'json') {
      this.jsonData = JSON.stringify(
        eval(`function getData () {${this.dataCode}; return data;} getData()`)
      );
    }
  }

  private async getFileList() {
    const result = await Message.emit('generator.scene.getFileList');
    this.fileList = result.data.list;
  }

  private openToolDialog(item) {
    this.toolVisible = true;
    AppModule.setSelecedFileInfo(item);
  }

  private async updateCodeData() {
    const result = await Message.emit('generator.scene.setVueGenerator', {
      boxUuid: AppModule.boxUuid,
      data: {
        code: this.dataCode
      }
    });

    if (result && result.status === 0) {
      this.$message({
        message: '操作成功',
        type: 'success'
      });
    }
  }

  private async addComponent(item) {
    const { path, key, params } = item;
    const param = {
      boxUuid: AppModule.boxUuid,
      id: key,
      params: params,
      path,
      type: 'custom',
    };
    Loading.open();
    await Message.emit('generator.scene.addComponent', param);
    Loading.close();
  }

  private searchChange(value) {
    this.getCustomComp(value);
  }

  private mousedownWidget (item) {
    this.widgetData = item;
    this.widgetData.id = this.widgetData.key;
    this.widgetData.type = 'custom';
    this.$root.$emit('mousedown_widget', this.widgetData);
  }

  private async openDrawerHandler(item) {
    this.openDrawer = true;
    const res = await Message.emit('generator.scene.handlerLifeCycle', {
      uuid: item.uuid,
      data: {
        handler: 'getData'
      }
    });
    this.jsonData = JSON.stringify(res);
  }

  private async installPlugin() {
    Loading.open();
    const res = await Message.emit('generator.plugin.installPlugin', {
      packageName: this.packageName,
      installType: this.installType,
    });
  }

  private async getPlugin() {
    // const res = await Message.emit('generator.plugin.getPlugin', {
    //   packageName: this.packageName
    // });
    // const {list} = res;
    // this.pluginList = list;
  }
}
